import { ScrollArea } from '#GameFrontend/components/ui/scroll-area';
import { useLoading } from '#GameFrontend/contexts/LoadingContext';
import { generateFilenameByGene } from '#GameFrontend/unauthorized/lib/GeneSelecter';
import { Starter } from '#GameFrontend/unauthorized/types/Starter';
import { StarterFormProps } from '#GameFrontend/unauthorized/types/StarterForm';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface Step4Props {
	bloodline: Starter;
	formData: StarterFormProps;
}
const Step4: React.FC<Step4Props> = ({ bloodline, formData }) => {
	const { t } = useTranslation();
	const { isLoading, setIsLoading } = useLoading();
	const path = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_PORT !== '80' && process.env.REACT_APP_PORT !== '443' ? `:${process.env.REACT_APP_PORT}` : ''}/image/horses/starter/`;
	const filename = generateFilenameByGene(formData.genes, formData.horseIsMale);
	const [imagePath, setImagePath] = useState<string>(`${path}${bloodline.id}/${filename}.png`);
	const [error, setError] = useState<string>('');
	const handleImageLoad = () => {
		setIsLoading(false);
	};

	const handleImageError = () => {
		setIsLoading(false);
	};

	useEffect(() => {
		setIsLoading(true);
	}, []);

	return (
		<>
			<div className={`lg:py-6 lg:pl-6 xl:pl-0 flex-col flex-grow text-white text-center hidden lg:flex`}>
				<h2 className="text-4xl text-white mb-0 lg:mb-4 text-center drop-shadow-[0_4px_4px_rgba(0,0,0,0.4)] relative z-30">
					<div className="flex items-center justify-center">
						<svg
							width="65%"
							height="70"
							xmlns="http://www.w3.org/2000/svg"
							className="lg:hidden text-center inline-block"
						>
							<text x="50%" y="50" className="outlined-text svg-text font-lobster" textAnchor="middle">
								{formData.horseName}
							</text>
						</svg>
						<svg
							width={formData.horseName.length * 24}
							height="40"
							xmlns="http://www.w3.org/2000/svg"
							className="hidden lg:inline-block text-center overflow-visible p-1"
						>
							<text x="50%" y="30" className="outlined-text svg-text font-lobster" textAnchor="middle">
								{formData.horseName}
							</text>
						</svg>
						<div
							className={`sprite-46 active ${formData.horseIsMale ? 'male' : 'female'} cursor-pointer min-w-[42px]`}
						></div>
					</div>
				</h2>
				<img
					key={imagePath}
					src={imagePath}
					alt="Horse"
					className="object-contain w-full h-full"
					onLoad={handleImageLoad}
					onError={handleImageError}
				/>
			</div>
			<div className={`lg:pl-12 py-6 lg:pt-2 xl:p-6  flex-col flex-grow text-white`}>
				<div className="flex flex-grow flex-col">
					<h2 className="text-3xl font-normal xl:mb-2 font-lobster text-[#fb923c] drop-shadow-[0_4px_4px_rgba(0,0,0,0.4)] hidden lg:inline-block">
						<svg width="300" height="55" xmlns="http://www.w3.org/2000/svg" className="overflow-visible">
							<text x="10" y="50" className="outlined-text  svg-text-sm">
								{t('register.complete.title')}
							</text>
						</svg>
					</h2>
					<div className="flex flex-col mt-4">
						<ScrollArea className="flex rounded-md p-4 bg-amber-100 bg-opacity-25 shadow-md xl:mr-16 max-h-128 xl:max-h-full w-full">
							<h3 className="font-lobster text-3xl mb-4 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
								{t('register.complete.welcome', { username: formData.username })}
							</h3>
							<p className="text-sm leading-relaxed drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
								<Trans
									i18nKey="register.complete.verify"
									components={{
										span: <span className="text-[#fb923c]" />,
									}}
									values={{
										horseName: formData.horseName,
									}}
								>
									{
										'Before you can fully dive in to the game, please check your e-mails and verify your account. But hurry, <name>{{horseName}}</name> is waiting for you!'
									}
								</Trans>
							</p>
							<br />
							<p className="text-sm leading-relaxed drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
								{t('register.complete.close')}
							</p>
							<br />
							<p className="text-sm leading-relaxed drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
								{t('register.complete.goodbye')}
							</p>
						</ScrollArea>
					</div>
				</div>
			</div>
		</>
	);
};
export default Step4;
